// extracted by mini-css-extract-plugin
export default {"about":"About_about__7ahPr","desc":"About_desc__SOk60"};